<script>
/* eslint-disable no-console */
/**
 * Button component
 */
export default {
  data() {
    return {
      selectedId: this.value,
      passSelectedId: 0,
      passSelected: null,
      selected: null,
      options: [],
    }
  },
  watch: {   
    list: function(val) {
      if(this.auto && val.data.length == 1) {
        // this.value = val.data[0].id;
        this.selectedId = val.data[0].id;
        this.$emit('change', val.data[0].id);
      }

      if(this.passSelectedId != 0) {
        this.passSelected = val.data.find((item) => item.id == this.passSelectedId);
      }
    },
    value: function(val) {
      this.selectedId = val;
      this.passSelectedId = val;
    },
  },
  computed: {
    validation() {
      return this.require ? this.value != 0 : null;
    }
  },
  props: {
    id: {
      type: String,
    },
    label: {
      type: String,
      default: ''
    },
    first: {
      type: String,
      default: 'general.please-select'
    },
    optionKey: {
      type: String,
      default: 'id'
    },
    prefix: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      // default: 'name'
      default: 'label'
    },
    text2: null,
    value: {
      default: 0,
    },
    require: {
      default: false
    },
    auto: {
      default: false,
    },
    list: {},
    disabled: {
      default: false
    },
    editable: {
      default: true
    }
  },
  methods: {
    updateValue: function(event) {
      /* eslint-disable no-console */
      this.selectedId = event;
      this.$emit('input', event);
      this.$emit('change', event);

      // console.log(event);
    }
  }
};
</script>
<template>
  <div class="form-group">
      <b-form-group
        class="mb-3"
        :label="$t(label)"
        :label-for="id"
      >
        <div v-if="editable || passSelected == null">
          <b-form-select
            class="form-select"
            :id="id"
            :disabled="disabled"
            @change="($event) => updateValue($event)"
            :state="validation"
            v-model="selectedId"
          >
            <option v-for="(selectOption, indexOpt) in list.data" 
                  :key="indexOpt"
                  :value="selectOption[optionKey]"
            >
              <div v-if="text2 != null">
                {{ `${prefix}${selectOption[text]} - (${selectOption[text2]})${postfix}` }}
              </div>
              <div v-else>
                {{ `${prefix}${selectOption[text]}${postfix}` }}
              </div>
            </option>
            <template v-if="auto == false" v-slot:first>
              <option value="0" >{{$t(first)}}</option>
            </template>
          </b-form-select>
        </div>
        <div v-else>
          <b-form-input
            :id="id"
            :type="type"
            :disabled="true"
            :value="text2 != null ? `${passSelected[text]} - (${passSelected[text2]})` :  `${passSelected[text]}`"
            :state="validation"
          ></b-form-input>
        </div>
        <b-form-invalid-feedback v-show="require" :state="validation">
          <span>{{`${$t('general.please-enter')} ${$t(label)}`}}</span>
        </b-form-invalid-feedback>
      </b-form-group>
      
    
  </div>
</template>